import { useMemo } from "react";
import { useOrdreStore } from "@store/ordreStore";
import { navigateTo } from "context/navigation.service";

const STATUS_LABELS: Record<string, { label: string; type: "default" | "info" | "warning" }> = {
  a_preparer: { label: "À préparer", type: "default" },
  commande: { label: "Commande", type: "warning" },
  pret: { label: "Prêt", type: "info" },
  reception: { label: "Réceptionné", type: "default" },
  en_cours: { label: "En cours", type: "info" },
  devis: { label: "Devis", type: "warning" },
  accord: { label: "Accord", type: "info" },
  fin_de_travaux: { label: "Fin de travaux", type: "info" },
  facturation: { label: "Facturation", type: "warning" },
  disponible: { label: "Disponible", type: "info" },
  restitue: { label: "Restitué", type: "default" },
};

function StatusBadge({ label, type }: { label: string; type: "default" | "info" | "warning" }) {
  const styles = {
    default: "bg-neutral-100 text-neutral-500",
    info: "bg-blue-50 text-blue-500",
    warning: "bg-amber-50 text-amber-600",
  };
  return (
    <span className={`text-h3 px-3 py-1 rounded-full ${styles[type]}`}>
      {label}
    </span>
  );
}

export default function RecentOrdresWidget() {
  const ordres = useOrdreStore((s) => s.ordres);
  const recentOrdres = useMemo(() => ordres.slice(0, 5), [ordres]);

  return (
    <div className="flex flex-col bg-white border rounded-xl p-4 gap-2 shadow-lg">
      <div className="flex flex-row justify-between items-center mb-2">
        <div className="font-semibold text-black">Ordres récents</div>
        <button
          onClick={() => navigateTo({ route: "/ordres" })}
          className="text-h3 text-neutral-400 hover:text-neutral-600"
        >
          Voir tout
        </button>
      </div>
      <div className="flex flex-col divide-y">
        {recentOrdres.length === 0 && (
          <div className="text-h3 text-neutral-300 py-3 px-2">Aucun ordre</div>
        )}
        {recentOrdres.map((order) => {
          const statusInfo = STATUS_LABELS[order.status] || { label: order.status, type: "default" as const };
          return (
            <div
              key={order.id}
              className="flex flex-row items-center py-3 px-2 gap-3 cursor-pointer hover:bg-neutral-50 rounded-lg"
              onClick={() => navigateTo({ route: `/ordre/${order.id}` })}
            >
              <div className="flex flex-col flex-1 min-w-0">
                <div className="text-h2 font-medium text-black">{order.name}</div>
                <div className="text-h3 text-neutral-400">{order.immatriculation}</div>
              </div>
              <StatusBadge label={statusInfo.label} type={statusInfo.type} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
